import {gql} from "@apollo/client";

export const LOGO_FRAGMENT = gql`
	fragment PictureFields on UserPicture {
		id
		badge:url (version:BADGE)
		thumbnail: url(version:THUMBNAIL)
	}
`;

export const USER_FRAGMENT = gql`
	fragment UserFields on User {
		id
		email
		status
		firstName
		lastName
		gender
		birthdate
		bio
		city
		registeredAt
		completedSurveysCount
		isPublic
		creatorTag
		country {
			id
			name
		}
		ethnicity {
			id
			name
		}
		followedBrands {
			id
			name
			description
			logoUrl
			logoPicture {
				url(version:MEDIUM)
			}
			global
		}
		followRequests {
			userId
			brandId
			status
		}
		picture {
			...PictureFields
		}
	}
	${LOGO_FRAGMENT}
`;

export const SURVEY_FRAGMENT = gql`
	fragment SurveyFields on Survey {
		id
		workspaceId
		title
		accessLevel
		status
		questionCount
		closeAt
		closeAfterResponsesCount
		completedResponseCount
		answeredByMe
		submittedAt
		workspace {
			brand {
				logoUrl
				logoPicture {
					url(version:MEDIUM)
				}
			}
		}
	}
`;
